export default __webpack_public_path__ + "static/media/menu_lend.08847b31.svg";